import { ActiveStep } from '../gift-card-layout/gift-card-layout';
import styles from './configurator-menu.module.scss';
import cn from 'classnames';

interface ConfiguratorMenuItemProps {
  readonly stepNumber: string;
  readonly stepName: ActiveStep;
  readonly activeStep: string;
  readonly onClick: (step: ActiveStep) => void;
  readonly disabled?: boolean;
}

const ConfiguratorMenuItem: React.FC<
  React.PropsWithChildren<ConfiguratorMenuItemProps>
> = ({ children, stepNumber, stepName, activeStep, onClick, disabled }) => {
  return (
    <li
      className={cn(styles.item, {
        [styles.active]: stepName === activeStep,
        [styles.disabled]: disabled,
      })}
      onClick={() => onClick(stepName)}
    >
      <div className={styles.itemContainer}>
        <div className={styles.stepNumber}>{stepNumber}</div>
        <span className={styles.stepName}> {children}</span>
      </div>
    </li>
  );
};

export default ConfiguratorMenuItem;
